<app-page-title [title]="'Online Test Requirements'"></app-page-title>
<hr />
<app-web-delivery
    *ngIf="reg"
    [isUpcomingTest]="false"
    [reg]="reg"
></app-web-delivery>
